export const PROMOTION_CONSTRAINTS = {
    name: { maxLength: 100, label: 'Promotion name' },
    type: { label: 'Type' },
    brand: { label: 'Brand' },
    brandPct: { label: 'Brand %' },
    accountPct: { label: 'Account %' },
    pct: { min: 0, max: 100 },
    categoryIds: { label: 'Categories', maxItems: 200 },
    messages: {
        percentagesRequired: 'Brand % and Account % are required for a Percentage Match promotion.',
        categoryRequired: 'Select at least one category for a Product promotion.',
    },
};
//# sourceMappingURL=constraints.js.map